import React from 'react'
import MyButton from '../../../../UI/form/MyButton'
import { useState } from 'react'
import MyModal from '../../../../UI/modal/MyModal'
import LogoutIcon from '@mui/icons-material/Logout';
import UserLogoutForm from './UserLogoutForm';

const UserLogoutButton = () => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
            color='red'
        >
            <LogoutIcon />
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Вийти з облікового запису'}
            disableClickOutside={true}
            content={
                <UserLogoutForm
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default UserLogoutButton